// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__zoeuj","shortcutText":"mimic___style_shortcutText__MXVTi"};